import type { BrandSpecialUserSegments } from '@iheartjane/types';

import { extractUserSegments } from './extractUserSegments';

export const brandSpecialHasSegments = (
  brandSpecial: BrandSpecialUserSegments
) => {
  const { includes, excludes } = extractUserSegments({ brandSpecial });

  return includes.length > 0 || excludes.length > 0;
};
